const charToValue = (char: string): number => {
  return char.charCodeAt(0) - 48;
};

function getCNPJVerifierDigit(digits: string): string {
  const factors1 = digits.padStart(13, '0').split('').map(charToValue);

  const factors2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const sumProduct = factors1.reduce((acc, cur, i) => acc + cur * factors2[i], 0);

  const mod = sumProduct % 11;
  return String(mod < 2 ? 0 : 11 - mod);
}

export function isValidCNPJ(cnpj: string): boolean {
  if (typeof cnpj !== 'string') return false;

  cnpj = cnpj.toUpperCase().replace(/[^0-9A-Z]/g, '');

  // should be 14 characters (12 digits + 2 verifier digits)
  if (cnpj.length !== 14) return false;

  // last 2 characters must be numeric
  if (!/^[0-9A-Z]{12}\d{2}$/.test(cnpj)) return false;

  // avoid repeated sequences like AAAAAAAAAAAAAA, 11111111111111 etc
  if (/^([0-9A-Z])\1+$/.test(cnpj)) return false;

  const digits = cnpj.substring(0, 12);
  const verifierDigit1 = getCNPJVerifierDigit(digits);
  const verifierDigit2 = getCNPJVerifierDigit(digits + verifierDigit1);

  return verifierDigit1 + verifierDigit2 === cnpj.substring(12);
}

export function isValidCPF(cpf: string): boolean {
  if (typeof cpf !== 'string' || !cpf || !/^\d{11}$/.test(cpf)) return false;

  // 00000000000, 11111111111, etc CPFs are invalid
  if (/^(\d)\1+$/.test(cpf)) return false;

  const digits = cpf.substring(0, 9);
  const verifierDigit1 = getCPFVerifierDigit(digits);
  const verifierDigit2 = getCPFVerifierDigit(digits + verifierDigit1);

  return verifierDigit1 + verifierDigit2 === cpf.substring(9);
}

function getCPFVerifierDigit(digits: string): string {
  const factors1 = digits
    .padStart(10, '0')
    .split('')
    .map((e) => parseInt(e));
  const factors2 = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
  const sumProduct = factors1.reduce((acc, cur, i) => acc + cur * factors2[i], 0);
  const mod = (sumProduct * 10) % 11;
  return mod === 10 ? '0' : mod.toFixed(0);
}

export function isValidCpfOrCnpj(text: string) {
  return Boolean(text) && (isValidCPF(text) || isValidCNPJ(text));
}
